import { motion } from 'framer-motion'

interface ProgressBarProps {
  currentStep: number
  totalSteps: number
  showStepCount?: boolean
}

export function ProgressBar({ currentStep, totalSteps, showStepCount = true }: ProgressBarProps) {
  const progress = ((currentStep + 1) / totalSteps) * 100

  return (
    <div className="fixed top-0 right-0 left-0 z-50">
      <div className="bg-surface h-1">
        <motion.div
          className="bg-accent h-full"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        />
      </div>
      {showStepCount && (
        <div className="text-foreground-muted absolute top-4 right-4 text-sm font-medium">
          {currentStep + 1} / {totalSteps}
        </div>
      )}
    </div>
  )
}
